import { useWeather, type WeatherPeriod } from "../state";

function WeatherCard({
  data,
  current = false,
}: {
  data: WeatherPeriod;
  current?: boolean;
}) {
  return (
    <div className="grid grid-cols-2 items-center text-2xl">
      <img
        src={`/assets/icons/weather/${data.icon}.svg`}
        alt={data.description}
        className="h-5/6"
      />
      <span className="text-black/70">{data.temp}°</span>
      <div className={`text-black/70 ${current ? "font-bold" : ""}`}>
        {data.label}
      </div>
    </div>
  );
}

export function Weather() {
  const weather = useWeather();

  if (!weather) {
    return (
      <div className="h-full flex flex-col items-center justify-center p-4">
        <div className="text-black/40">Laden...</div>
      </div>
    );
  }

  return (
    <div className="h-full flex items-center justify-start mx-4 my-2">
      <WeatherCard data={weather.current} current={true} />
      {weather.forecasts.map((forecast, i) => (
        <WeatherCard key={i} data={forecast} />
      ))}
    </div>
  );
}
